module.exports = __webpack_public_path__ + "static/media/bensad-min.ff015940.ogg";